import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    messagesReplace: (state, action) => {
      return action.payload;
    },
    messagesAppend: (state, action) => {
      state.push(action.payload);
    },
    messagesClear: (state) => {
      return [];
    },
    lastMessageAppend: (state, action) => {
      state[state.length - 1].content += action.payload;
    },
    lastMessageReplace: (state, action) => {
      state[state.length - 1].content = action.payload;
    },
  },
});

export const {
  messagesReplace,
  messagesAppend,
  messagesClear,
  lastMessageAppend,
  lastMessageReplace,
} = messagesSlice.actions;

export default messagesSlice.reducer;
